export enum Events {
	DISH_VISIT= 'dish_visit',
	MENU_VISIT = 'menu_visit'
}